export default "__VITE_ASSET__ii_joCbs__"